import React from 'react';
import { motion } from 'framer-motion';
const galleryItems = [{
  id: 1,
  image: 'https://cdn.magicpatterns.com/uploads/rUtz19NDvCceG1Vh5ULJ7Z/kbella-interior.webp',
  alt: "K'Bella Spa interior lobby"
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/uploads/cqhxXp8NvPnbNnFjNn9nvC/kbella-interior-2.webp',
  alt: "K'Bella Spa reception area"
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/uploads/kj36NXFA9PEr3qhmNhfoFm/kbella-interior-3.jpg',
  alt: 'Karen performing a treatment'
}, {
  id: 4,
  image: 'https://cdn.magicpatterns.com/uploads/fcrrMEcD26PwxKrhuRUbAj/kbella-interior-4.jpg',
  alt: 'Wellness Pro treatment equipment'
}];
export function Gallery() {
  return <section id="gallery" className="py-20 md:py-32 bg-brand-gray relative overflow-hidden" data-id="element-99">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-100">
        <div className="text-center mb-16" data-id="element-101">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-brand-charcoal mb-4" data-id="element-102">
            Step Inside K'Bella
          </h2>
          <div className="w-16 h-1 bg-brand-teal mx-auto mt-6" data-id="element-103"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-104">
          {galleryItems.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative overflow-hidden rounded-xl shadow-md group" data-id="element-105">
              <img src={item.image} alt={item.alt} className="w-full h-72 md:h-80 object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-106" />
              <div className="absolute inset-0 bg-brand-teal/0 group-hover:bg-brand-teal/20 transition-colors duration-300" data-id="element-107"></div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}